import { Trans } from '@lingui/macro'
import { Alert, AlertTitle } from '@mui/material'
import { ReduxState } from 'app/redux/ReduxInterfaces'
import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'
import React from 'react'
import { useSelector } from 'react-redux'

export const IncompleteOrganizationDetails: React.FC = () => {
  const simulateInternal = useSelector<ReduxState, boolean>(
    state => state?.testingOptions?.simulateInternal)
  const isInternal = simulateInternal || sfOauthConfig.isInternal as boolean

  if (isInternal) return null

  return (
    <Alert variant='filled' severity='info'>
      <AlertTitle>
        <Trans>INCOMPLETE_ORGANIZATION_DETAILS_TITLE_ALERT</Trans>
      </AlertTitle>
      <Trans>INCOMPLETE_ORGANIZATION_DETAILS_DESCRIPTION_ALERT</Trans>
    </Alert>
  )
}
